export default __webpack_public_path__ + "static/media/germany-icon.17b468de.svg";